<div class="main-container" [class.main-is-mobile]="mobileQuery.matches">
  <bt-navbar (toggleSidenav)="snav.toggle()"></bt-navbar>

  <mat-sidenav-container class="main-sidenav-container">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [autoFocus]="false"
      [fixedInViewport]="mobileQuery.matches" [opened]="!mobileQuery.matches">
      <mat-nav-list>
        <div class="user-indicator">
          <div class="profile">
            <span class="fa fa-user"></span>
          </div>
          <div class="info">
            <div>{{fullName}}</div>
            <div class="role">{{roleTitle}}</div>
          </div>
        </div>

        <ng-container *ngFor="let menu of menus">
          <div class="menu-container">
            <div class="header" [routerLink]="menu.link" [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: menu.link === '/' }">
              <div class="head">
                <mat-icon>{{menu.icon}}</mat-icon>
                <span>{{menu.title}}</span>
              </div>

              <div class="sub-menu-container" *ngIf="menu.children.length">
                <div (click)="$event.stopPropagation()" *ngFor="let child of menu.children" class="sub-menu"
                  [routerLink]="child.link" [routerLinkActive]="'active-sub'">
                  <mat-icon>arrow_back_ios</mat-icon>
                  <span>{{child.title}}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <a mat-list-item (click)="onLogout()">
          <span class="menu-item-icon">
            <mat-icon>power_settings_new</mat-icon>
          </span>
          <span>خارج شدن</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="body">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
